"use client"

import { useEffect, useState } from "react"
import { useRouter } from "next/navigation"
import { useSelector } from "react-redux"
import { selectLanguage, selectUser } from "@/app/redux/store"


import ProjectCard from "../project-card/project-card"
import Label from "../label/Label"
import { getAllCurrentsProjectsByType, getAllUsersByPartner, getLabels, getPartner } from "@/app/adapters/api"
import { GridSkeleton } from "../../skeleton/gridSkeleton"

const labelsNames = [
  "preference-option-one",
  "preference-option-two",
  "preference-option-three",
]

export default function CurrentInvestments(props: { type: string, isOnImpactNetworkPage?: boolean }) {

  const [loading, setLoading] = useState(true)
  const [labels, setLabels] = useState<any>({})
  const lang = useSelector(selectLanguage)
  const userState = useSelector(selectUser)
  const [currentProjects, setCurrentProjects] = useState<any>([])
  const [availableCurrentProjects, setAvailableCurrentProjects] = useState(0)
  const [projectTypeSelected, setProjectTypeSelected] = useState(props.type)
  const [skip, setSkip] = useState(0)
  const [limit, setLimit] = useState(6)

  // if (typeof window !== 'undefined') {
  //   localStorage.setItem('lastPath', `/oportunidades-inversion`)
  // }

  useEffect(() => {
    getLabels(labelsNames)
      .then((response) => {
        setLabels(response.data.labels)
      })
      .finally(() => {
        setLoading(false)
      });
  }, [])

  useEffect(() => {
    loadProjects(projectTypeSelected)
  }, [projectTypeSelected])


  const loadProjects = async (projectType: string) => {
    setLoading(true)
    try {
      const response = await getAllCurrentsProjectsByType(projectType, skip, limit)
      const projectsIn = response.data.projects;
      const updatedProjects = await Promise.all(projectsIn.map(async (project: any) => {
        if (project?.exclusive === true && project?.status === 'precampaign' && userState.isLogin) {
          const partnerIds = project.projectPartners.map((partnerObj: any) => partnerObj.partner);
          const showResults = await Promise.all(partnerIds.map(async (partnerId: any) => {
            const partnerResponse = await getPartner(partnerId)
            const userResponses = await getAllUsersByPartner(partnerId, partnerResponse.data.partner.access)
            const partnerUsersIds = userResponses.data.partnerUsers.map((user: any) => user.partnerUser.id);
            const usersWithPartnerCodeIds = userResponses.data.usersWithPartnerCode.map((user: any) => user.id);
            const allUserPartners = [...partnerUsersIds, ...usersWithPartnerCodeIds];
            return allUserPartners.includes(userState.id);
          }));
          project.show = showResults.includes(true);
           if (!project.show) {
            console.log(`Project ${project.id} is exclusive and user is not a partner`);
          }
        } else {
          project.show = !project?.exclusive;
        }
        return project;
      }));
  
      const filteredProjects = updatedProjects.filter((project: any) => project.show);
      setCurrentProjects(filteredProjects)
      setAvailableCurrentProjects(response.data.totalProjects)
      const newSkip = skip + limit;
      setSkip(newSkip)
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false)
    }
  };

  const handleSelectProjectType = (projectType: string) => {
    // if (projectType === 'all') {
    //   router.push(`/oportunidades-inversion/`)
    // } else if (projectType === 'equity') {
    //   router.push(`/oportunidades-inversion/startup-equity/`)
    // } else if (projectType === 'lending') {
    //   router.push(`/oportunidades-inversion/empresas-lending/`)
    // }
    setSkip(0);
    setProjectTypeSelected(projectType)
  }

  const handleAddProjects = () => {
    getAllCurrentsProjectsByType(projectTypeSelected, skip, limit)
      .then((response) => {
        const newProjects = [...currentProjects, ...response.data.projects]
        setCurrentProjects(newProjects)
        setAvailableCurrentProjects(response.data.totalProjects)
        const newSkip = skip + limit;
        setSkip(newSkip)
      })
      .finally(() => {
        setLoading(false)
      });
  }

  return (
    <section className="my-4">
      <div className={`flex justify-center items-center divide-x-2 ${props.isOnImpactNetworkPage ? "divide-impact-dark-green" : "divide-lbs-secondary-orange"} `}>
        <p onClick={() => handleSelectProjectType('all')}
          className={"w-[180px] text-sm	sm:text-2xl px-4 py-2 text-center font-bold cursor-pointer " + (projectTypeSelected === "all"
            ? "text-lbs-secondary-orange" : "hover:text-lbs-secondary-orange")}>
          <Label label={labels.preferenceOptionOne} lang={lang} />
        </p>
        {/* <Link href="/oportunidades-inversion/"> 
            <p className={"w-[180px] text-sm	sm:text-2xl px-4 py-2 text-center font-bold cursor-pointer " + (projectTypeSelected === "all" 
                          ? (props.isOnImpactNetworkPage ? "text-impact-green" :"text-lbs-secondary-orange") : (props.isOnImpactNetworkPage ? "hover:text-impact-dark-green" :"hover:text-lbs-secondary-orange"))}>
                <Label label={labels.preferenceOptionOne	} lang={lang}/>
            </p>
          </Link> */}
        <p onClick={() => handleSelectProjectType('equity')}
          className={"w-[180px] text-sm	sm:text-2xl px-4 py-2 text-center font-bold cursor-pointer " + (projectTypeSelected === "equity"
            ? "text-lbs-secondary-orange" : "hover:text-lbs-secondary-orange")}>
          <Label label={labels.preferenceOptionTwo} lang={lang} />
        </p>
        {/* <Link href="/productos-inversion/equity/">        
            <p className={"w-[180px] text-sm	sm:text-2xl px-4 py-2 text-center font-bold cursor-pointer " + (projectTypeSelected === "equity" 
                          ? (props.isOnImpactNetworkPage ? "text-impact-green" : "text-lbs-secondary-orange")  : (props.isOnImpactNetworkPage ? "hover:text-impact-dark-green" :"hover:text-lbs-secondary-orange"))}>
                <Label label={labels.preferenceOptionTwo	} lang={lang}/>
            </p>
          </Link> */}
        <p onClick={() => handleSelectProjectType('lending')}
          className={"w-[180px] text-sm	sm:text-2xl px-4 py-2 text-center font-bold cursor-pointer " + (projectTypeSelected === "lending"
            ? "text-lbs-secondary-orange" : "hover:text-lbs-secondary-orange")}>
          <Label label={labels.preferenceOptionThree} lang={lang} />
        </p>
        {/* <Link href="/productos-inversion/lending/">
            <p className={"w-[180px] text-sm	sm:text-2xl px-4 py-2 text-center font-bold cursor-pointer " + (projectTypeSelected === "lending" 
                          ? (props.isOnImpactNetworkPage ? "text-impact-green" : "text-lbs-secondary-orange")  : (props.isOnImpactNetworkPage ? "hover:text-impact-dark-green" :"hover:text-lbs-secondary-orange"))}>
                <Label label={labels.preferenceOptionThree	} lang={lang}/>
            </p>
          </Link> */}
      </div>
      {
        loading ?
          <GridSkeleton />
          :
          <>
            <div className="flex justify-center flex-wrap gap-8	mt-8 p-4">
              {currentProjects.map((project: any) => {
                return <ProjectCard key={project.id} projectId={project.id} lang={lang} isOnImpactNetworkPage={props.isOnImpactNetworkPage} />
              })}
            </div>
            {
              availableCurrentProjects > skip ?
                <div className="flex justify-center mt-4 mb-8">
                  <button
                    className={`w-[44px] h-[44px] text-2xl rounded-full ${props.isOnImpactNetworkPage ? "bg-impact-green" : "bg-lbs-secondary-orange"}  text-white cursor-pointer`}
                    onClick={handleAddProjects}>+</button>
                </div>
                :
                null
            }
          </>
      }
    </section>
  )
}
